<main class="main container">
  <router-outlet></router-outlet>
</main>
<footer class="footer">
  <app-footer ngClass="container"></app-footer>
</footer>
